import __request__ from "routing/request";
export function createClientCert(request, requestOptions) {
  return __request__("POST", "/ca/clientcert", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteClientCert(role, principal, requestOptions) {
  return __request__("DELETE", `/ca/clientcert/${role}/${principal}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
